import { type Result, fail } from '@core/domain/utils/Result.ts';
import type {
  AppMaintenancePort,
  AppMaintenanceResetOptions,
} from '../domain/ports/AppMaintenancePort.ts';

export type AppMaintenancePendingUploadGuard = () => { puntosEntrega: number; redenciones: number };

/** Orchestrates cache wipe / optional local SQLite reset before reload. */
export class AppMaintenanceApplicationService implements AppMaintenancePort {
  constructor(
    private readonly delegate: AppMaintenancePort,
    private readonly pendingUploadGuard?: AppMaintenancePendingUploadGuard,
  ) {}

  getRuntimeInfo() {
    return this.delegate.getRuntimeInfo();
  }

  async resetApplication(options: AppMaintenanceResetOptions): Promise<Result<void, string>> {
    if (options.wipeLocalSqlite && this.pendingUploadGuard) {
      const pending = this.pendingUploadGuard();
      const total = pending.puntosEntrega + pending.redenciones;
      if (total > 0) {
        return fail(
          `Hay ${total} registro(s) pendientes de envío. Sincronice o desmarque la opción de eliminar datos locales antes de continuar.`,
        );
      }
    }
    return this.delegate.resetApplication(options);
  }
}
